import { render, staticRenderFns } from "./SmsTest.vue?vue&type=template&id=50376ded&scoped=true"
import script from "./SmsTest.vue?vue&type=script&lang=js"
export * from "./SmsTest.vue?vue&type=script&lang=js"
import style0 from "./SmsTest.vue?vue&type=style&index=0&id=50376ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50376ded",
  null
  
)

export default component.exports